import { Result } from "antd";
import { createBrowserRouter, createRoutesFromElements, Route } from "react-router-dom";
import Login from "../screens/Auth/Login/Login";
import Signup from "../screens/Auth/SignUp/Signup";
import { ProtectedLayout } from "./ProtectedRoutes";
import { HomeLayout } from "./PublicRoutes";
import AdminDashboard from "../screens/AdminScreens/AdminDashboard/AdminDashboard";
import Yardsales from "../screens/AdminScreens/Yardsales/Yardsales";
import CreateNewUser from "../screens/AdminScreens/CreateNewUser/CreateNewUser";
import YardsaleDetails from "../screens/AdminScreens/YardsaleDetails/YardsaleDetails";
import TermsConditions from "../screens/TermsConditions/TermsConditions";
import PrivacyPolicy from "../screens/PrivacyPolicy/PrivacyPolicy";
import HelpSupport from "../screens/HelpSupport/HelpSupport";
import Setting from "../screens/Settings/Setting";
import FAQs from "../screens/FAQs/FAQs";
import Payments from "../screens/Payments/Payments";
import UserDetails from "../screens/AdminScreens/UserDetails/UserDetails";
import About from "../screens/About/About";
import WebsiteQueries from "../screens/WebsiteQueries/WebsiteQueries";

export const router = createBrowserRouter(createRoutesFromElements(
    <>
      <Route element={<HomeLayout />}>
        <Route path="/" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
      </Route>

      <Route element={<ProtectedLayout />}>
        <Route path="/AdminDashboard" element={<AdminDashboard />} />
        <Route path="/CreateNewUser" element={<CreateNewUser />} />
        <Route path="/Yardsales" element={<Yardsales />} />
        <Route path="/YardsaleDetails" element={<YardsaleDetails />} />
        <Route path="/UserDetails" element={<UserDetails />} />


        <Route path="/YardsaleDetails" element={<YardsaleDetails />} />
        <Route path="/TermsConditions" element={<TermsConditions />} />
        <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/HelpSupport" element={<HelpSupport />} />
        <Route path="/setting" element={<Setting />} />
        <Route path="/FAQs" element={<FAQs />} />
        <Route path="/Payments" element={<Payments />} />
        <Route path="/About" element={<About />} />
        <Route path="/WebsiteQueries" element={<WebsiteQueries />} />



      </Route>

  
      <Route
        path="*"
        element={
          <Result
            status="404"
            title="404"
            subTitle="Sorry, the page you visited does not exist."
          // extra={<Button type="primary">Back Home</Button>}
          />
        }
      />
    </>
  )
);
